import { Route, Routes } from "react-router-dom";
import Markdown from '../markdown/markdown'


const Markdown_rou = () => {
    return <>
    <Markdown/>
    </>
}

export default Markdown_rou;